// extracted by mini-css-extract-plugin
module.exports = {"bg":"_de","bg__imgWrapper":"_df","bg__img":"_dh"};